module.exports = __webpack_public_path__ + "img/banner.1cbaa92e.png";